import React from 'react';

import { InlineEditorProps, Widget } from './_InlineDraftEditor';

export function BooleanWidget(props: Widget<boolean>) {
  return (
    <span
      style={{cursor: 'pointer'}}
      onDoubleClick={() => props.onValueChange(!props.value)}
    >
      {props.value ? 'true' : 'false'}
    </span>
  );
}

export const BooleanInlineEditor = (props: InlineEditorProps) => {
  return (
    <span className="inline-editor" onClick={() => props.onValueChange(!props.value)}>
      {props.label}
      <span className="equal-sign">=</span>
      <span className="inline-displayed-value boolean-value">
        {props.value ? 'true' : 'false'}
      </span>
    </span>
  );
};
